// extracted by css-extract-rspack-plugin
export default {"size400":"400px","dialogContainer":"genesis-generic-error-dialog__dialogContainer___epwjX","dialogBody":"genesis-generic-error-dialog__dialogBody___jFQfF"};